module.exports = __webpack_public_path__ + "static/media/rainbow.d2357580.svg";